<template>
    <div>
        <createRoom v-if="currentStep==1"></createRoom>
        <room-dashboard v-show="currentStep==2" :table="table" :matches="matches"></room-dashboard>
        <matches v-show="currentStep==3" :table="table" :matches="matches"></matches>
    </div>
</template>

<script>
    import RoomDashboard from "./RoomDashboard";
    import CreateRoom from "./CreateRoom";
    import Matches from "./Matches";

    export default {
        components: {Matches, RoomDashboard, CreateRoom },
        data: function () {
            return {
                currentStep: 1,
                room: null,
                table: [],
                matches: collect(),
            }
        },

        methods: {

        },

        created() {
            Quiz.$on('scholar-room-created', (data) => {
                this.room = data
                this.currentStep = 2;
            })

            Quiz.$on('scholar-game-started', () => {
                this.currentStep = 3;
            })

            Quiz.$on('scholar-game-restart', () => {
                this.currentStep = 2;
            })

            Quiz.$on('spectator', (message) => {
                if (get(message.data.info, 'table', null)) {
                    this.table = message.data.info.table
                }

                if (! this.matches.first(item => item.id === message.data.info.quiz.id)) {
                    this.matches.push(message.data.info.quiz)
                } else {
                    this.matches.transform((item) => {
                        if (item.id === message.data.info.quiz.id) {
                            item.status = message.data.info.quiz.status
                            item.quizUsers = message.data.info.quiz.quizUsers
                        }

                        return item
                    })
                }
            })
        },

        beforeDestroy() {
            Quiz.$off('spectator')
            Quiz.$off('scholar-game-restart')
            Quiz.$off('scholar-game-started')
            Quiz.$off('scholar-room-created')
        }
    }
</script>
